import React, { useEffect, useRef } from 'react';
var FilterTypeConfig = /** @class */ (function () {
    function FilterTypeConfig() {
    }
    return FilterTypeConfig;
}());
var CommentSidebarFilterConfig = /** @class */ (function () {
    function CommentSidebarFilterConfig() {
    }
    return CommentSidebarFilterConfig;
}());
;
var CommentSidebarGroupConfig = /** @class */ (function () {
    function CommentSidebarGroupConfig() {
    }
    return CommentSidebarGroupConfig;
}());
var CommentSidebarFilters = /** @class */ (function () {
    function CommentSidebarFilters() {
    }
    return CommentSidebarFilters;
}());
var SnippylySidebarButton = function (props) {
    var tooltipText = props.tooltipText, children = props.children, darkMode = props.darkMode, shadowDom = props.shadowDom, floatingMode = props.floatingMode, pageMode = props.pageMode, sortData = props.sortData, urlNavigation = props.urlNavigation, currentLocationSuffix = props.currentLocationSuffix, filterConfig = props.filterConfig, groupConfig = props.groupConfig, filters = props.filters, excludeLocationIds = props.excludeLocationIds, dialogVariant = props.dialogVariant, pageModeComposerVariant = props.pageModeComposerVariant, sidebarShadowDom = props.sidebarShadowDom, sidebarVariant = props.sidebarVariant, position = props.position, onCommentClick = props.onCommentClick, onSidebarOpen = props.onSidebarOpen, filterPanelLayout = props.filterPanelLayout, sidebarButtonCountType = props.sidebarButtonCountType, filterGhostCommentsInSidebar = props.filterGhostCommentsInSidebar, commentCountType = props.commentCountType;
    var ref = useRef();
    var onSidebarOpenRef = useRef(onSidebarOpen);
    var onCommentClickRef = useRef(onCommentClick);
    useEffect(function () {
        onCommentClickRef.current = onCommentClick;
    }, [onCommentClick]);
    useEffect(function () {
        onSidebarOpenRef.current = onSidebarOpen;
    }, [onSidebarOpen]);
    useEffect(function () {
        var element;
        var handleSidebarOpen = function (event) {
            if (onSidebarOpenRef.current) {
                onSidebarOpenRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleSidebarCommentClick = function (event) {
            if (onCommentClickRef.current) {
                onCommentClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onSidebarOpen', handleSidebarOpen);
                element.addEventListener('onCommentClick', handleSidebarCommentClick);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onSidebarOpen', handleSidebarOpen);
                element.removeEventListener('onCommentClick', handleSidebarCommentClick);
            }
        };
    });
    return (React.createElement("velt-sidebar-button", { "tooltip-text": tooltipText, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, "floating-mode": [true, false].includes(floatingMode) ? (floatingMode ? 'true' : 'false') : undefined, ref: ref, "page-mode": [true, false].includes(pageMode) ? (pageMode ? 'true' : 'false') : undefined, "sort-data": sortData, "url-navigation": [true, false].includes(urlNavigation) ? (urlNavigation ? 'true' : 'false') : undefined, "current-location-suffix": [true, false].includes(currentLocationSuffix) ? (currentLocationSuffix ? 'true' : 'false') : undefined, "filter-config": filterConfig ? JSON.stringify(filterConfig) : undefined, "group-config": groupConfig ? JSON.stringify(groupConfig) : undefined, filters: filters ? JSON.stringify(filters) : undefined, "exclude-location-ids": excludeLocationIds ? JSON.stringify(excludeLocationIds) : undefined, "dialog-variant": dialogVariant, "page-mode-composer-variant": pageModeComposerVariant, "sidebar-shadow-dom": [true, false].includes(sidebarShadowDom) ? (sidebarShadowDom ? 'true' : 'false') : undefined, "sidebar-variant": sidebarVariant, position: position, "filter-panel-layout": filterPanelLayout, "sidebar-button-count-type": sidebarButtonCountType, "filter-ghost-comments-in-sidebar": [true, false].includes(filterGhostCommentsInSidebar) ? (filterGhostCommentsInSidebar ? 'true' : 'false') : undefined, "comment-count-type": commentCountType }, children));
};
export default SnippylySidebarButton;
